export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7827.93de6bf0.jpg";